import { InjectionToken } from '@angular/core';
import { Environment } from './interfaces/env';

export interface PicflowConfig {
  apiEndpoint: string;
  socketEndpoint: string;
  authClientID: string;
  authDomain: string;
  intercomAppId: string;
  _assetsEndpoint: string;
  archivesEndpoint: string;
  stripePublishableKey: string;
  customerIoSiteId: string;
  env: Environment;
  origin: string;
  gtmWorkspaceId: string;
  gtmEnvironmentExtra: string;
  cioKey: string;
  isTenantDomain: boolean;
  customDomainCnameValue: string;
  lightroomAuthClientId: string; // Clerk OAuth app client ID for Lightroom plugin
  growthBookKey: string;
  assetsEndpoint: string;
  useAbsoluteUrls: boolean;
  correctPicflowUrl: string;
  translationBase: string;
  internalApiUrlBase: string;
  version: string;
  captureOneLocalHost: string;
  wafEndpoint: string;
  storyblokUrl: string;
  clerkKey: string;
  appsyncEndpoint: string;
}

export const PICFLOW_CONFIG = new InjectionToken<PicflowConfig>('PicflowConfig');
